import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { ButtonGroup } from 'react-bootstrap'

export const FilterTypeButton = ({
  filterType,
  setFilterType,
}: {
  filterType: number
  setFilterType: React.Dispatch<React.SetStateAction<number>>
}) => {
  return (
    <ButtonGroup>
      <BusyButton
        active={filterType === 1}
        onClick={() => {
          setFilterType(1)
        }}
        icon={'star-half-stroke'}
        title={'Partial text search → this will search the product code only.'}
      />
      <BusyButton
        active={filterType === 2}
        onClick={() => {
          setFilterType(2)
        }}
        icon={'star'}
        title={'Full text search → this will search on the product name, code and full description.'}
      />
    </ButtonGroup>
  )
}
